import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(
            _vm.mode == "create"
              ? _vm.$t("chatbots.data_center.create_data_center")
              : _vm.mode == "edit"
              ? _vm.$t("chatbots.data_center.update_data_center")
              : _vm.$t("chatbots.data_center.view_data_center")
          )
        ),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(
                  _vm._s(_vm.$t("chatbots.data_center.data_center_description"))
                ),
              ]),
            ],
            1
          ),
          _c("template", { slot: "actions" }),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                { ref: "form_data_center", attrs: { id: "form_data_center" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.data_center.metadata.database"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              filled: _vm.view || _vm.edit,
                              disabled: _vm.view || _vm.edit,
                              dense: "",
                              outlined: "",
                              rules: _vm.rules.name,
                              items: _vm.database,
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.data_center.database_service,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data_center,
                                  "database_service",
                                  $$v
                                )
                              },
                              expression: "data_center.database_service",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("ID (VectorDatabase)"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VTextField, {
                            key: _vm.key_database_service_id,
                            attrs: {
                              filled: "",
                              readonly: "",
                              dense: "",
                              outlined: "",
                              disabled: _vm.view || _vm.edit,
                              rules: _vm.rules.database_service_id,
                            },
                            model: {
                              value: _vm.data_center.database_service_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data_center,
                                  "database_service_id",
                                  $$v
                                )
                              },
                              expression: "data_center.database_service_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbots.data_center.metadata.name")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.name,
                            },
                            on: { keyup: _vm.onChangeName },
                            model: {
                              value: _vm.data_center.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.data_center, "name", $$v)
                              },
                              expression: "data_center.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.data_center.metadata.description"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: _vm.view,
                              dense: "",
                              outlined: "",
                              disabled: _vm.view,
                              rules: _vm.rules.description,
                              rows: 2,
                            },
                            model: {
                              value: _vm.data_center.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.data_center, "description", $$v)
                              },
                              expression: "data_center.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbots.data_center.metadata.files")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          !_vm.view
                            ? _c(
                                "actions-component",
                                [
                                  _c(
                                    "template",
                                    { slot: "description" },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "btn-inca-secondary",
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            small: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDialog()
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s("Agregar Archivo"))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(VDataTable, {
                            staticClass: "table-inca table-inca-detail",
                            attrs: {
                              headers: _vm.headers_files,
                              items: _vm.filteredFiles,
                              "hide-default-footer": "",
                              "items-per-page": _vm.pagination_files.limit,
                              page: _vm.pagination_files.current,
                            },
                            on: {
                              pagination: function ($event) {
                                _vm.pagination_files.total = $event.itemsLength
                              },
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination_files,
                                  "current",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.name",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [_vm._v(_vm._s(item.name))]),
                                  ]
                                },
                              },
                              {
                                key: "item.type",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [_vm._v(_vm._s(item.type))]),
                                  ]
                                },
                              },
                              {
                                key: "item.embedded_column",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(item.embedded_column)),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRemoveFile(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("mdi-minus-circle-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm.edit && item.type != "CHATBOT_PDF"
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editRows(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-edit")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("pagination-vue", {
                            attrs: { pagination: _vm.pagination_files },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbots.data_center.metadata.qa")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          !_vm.view
                            ? _c(
                                "actions-component",
                                [
                                  _c(
                                    "template",
                                    { slot: "description" },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "btn-inca-secondary",
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            small: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addRowQA()
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s("Agregar Pregunta"))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(VDataTable, {
                            staticClass: "table-inca table-inca-detail",
                            attrs: {
                              headers: _vm.headers_qa,
                              items: _vm.filteredQa,
                              "hide-default-footer": "",
                              "items-per-page": _vm.pagination_qas.limit,
                              page: _vm.pagination_qas.current,
                            },
                            on: {
                              pagination: function ($event) {
                                _vm.pagination_qas.total = $event.itemsLength
                              },
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination_qas,
                                  "current",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.question",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(VTextarea, {
                                      attrs: {
                                        small: "",
                                        dense: "",
                                        outlined: "",
                                        disabled: item.qa_id ? true : false,
                                        filled: item.qa_id ? true : false,
                                        readonly: item.qa_id ? true : false,
                                        "hide-details": "auto",
                                        rules: _vm.rules.qa,
                                        counter: "",
                                        rows: "2",
                                      },
                                      model: {
                                        value: item.question,
                                        callback: function ($$v) {
                                          _vm.$set(item, "question", $$v)
                                        },
                                        expression: "item.question",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.answer",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(VTextarea, {
                                      attrs: {
                                        small: "",
                                        dense: "",
                                        outlined: "",
                                        disabled: item.qa_id ? true : false,
                                        filled: item.qa_id ? true : false,
                                        readonly: item.qa_id ? true : false,
                                        "hide-details": "auto",
                                        rules: _vm.rules.qa,
                                        counter: "",
                                        rows: "2",
                                      },
                                      model: {
                                        value: item.answer,
                                        callback: function ($$v) {
                                          _vm.$set(item, "answer", $$v)
                                        },
                                        expression: "item.answer",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRemoveQA(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("mdi-minus-circle-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("pagination-vue", {
                            attrs: { pagination: _vm.pagination_qas },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.userInfo.domain == "casa-andina.com"
                    ? [
                        _vm.data_center.documents_file && (_vm.view || _vm.edit)
                          ? _c(
                              VRow,
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(
                                      VSubheader,
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chatbots.data_center.metadata.documents_file"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "10" } },
                                  [
                                    _c(VTextField, {
                                      attrs: {
                                        small: "",
                                        dense: "",
                                        outlined: "",
                                        disabled: "",
                                        filled: "",
                                        readonly: "",
                                        value: _vm.data_center.documents_file[0]
                                          ? _vm.data_center.documents_file[0]
                                              .name
                                          : "",
                                        "hide-details": "auto",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.view
                          ? _c(
                              VRow,
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(
                                      VSubheader,
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          "Cargar " +
                                            _vm._s(
                                              _vm.$t(
                                                "chatbots.data_center.metadata.documents_file"
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "8" } },
                                  [
                                    _c(VFileInput, {
                                      attrs: {
                                        outlined: "",
                                        dense: "",
                                        label: "Seleccionar archivo",
                                        view: "",
                                        "hide-details": "auto",
                                        rules: _vm.edit
                                          ? []
                                          : _vm.rules.file_index,
                                      },
                                      model: {
                                        value: _vm.documents_file,
                                        callback: function ($$v) {
                                          _vm.documents_file = $$v
                                        },
                                        expression: "documents_file",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        attrs: {
                                          color: "primary",
                                          outlined: "",
                                          dense: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadExcelTemplate()
                                          },
                                        },
                                      },
                                      [_vm._v("Descargar plantilla")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(VRow, { attrs: { justify: "center" } }, [
            _c(
              "div",
              { staticClass: "mb-2" },
              [
                _c(
                  VBtn,
                  {
                    staticClass: "default mr-1",
                    attrs: {
                      id: "link_go_list_qualities",
                      name: "link_go_list_qualities",
                      outlined: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onCancelar()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("btns.back")))]
                ),
                _vm.view == false && _vm.tab != 2
                  ? _c(
                      VBtn,
                      {
                        staticClass: "primary mr-1",
                        attrs: {
                          id: "btn_save_profiling",
                          name: "btn_save_profiling",
                        },
                        on: {
                          click: function ($event) {
                            _vm.edit
                              ? _vm.onUpdateDataCenter()
                              : _vm.onSaveDataCenter()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("btns.save")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "DialogsComponent",
        {
          ref: "dialog",
          attrs: { title: "Agregar fuente de datos", width: 800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "", justify: "center" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v("Archivo :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VFileInput, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              label: "Seleccionar archivo",
                              view: "",
                              "hide-details": "auto",
                              rules: _vm.rules.file_vs,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleFileUpload(
                                  _vm.item_modal,
                                  $event
                                )
                              },
                            },
                            model: {
                              value: _vm.item_modal.file,
                              callback: function ($$v) {
                                _vm.$set(_vm.item_modal, "file", $$v)
                              },
                              expression: "item_modal.file",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "", justify: "center" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v("Tipo de archivo :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VSelect, {
                            attrs: {
                              small: "",
                              dense: "",
                              outlined: "",
                              items: _vm.file_types,
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.item_modal.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.item_modal, "type", $$v)
                              },
                              expression: "item_modal.type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.item_modal.type == "CHATBOT_EXCEL"
                    ? _c(
                        VRow,
                        { attrs: { dense: "", justify: "center" } },
                        [
                          _c(
                            VCol,
                            { staticClass: "col-md-3" },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold p-0" },
                                [_vm._v("Columna :")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { staticClass: "col-md-9" },
                            [
                              _c(VSelect, {
                                key: _vm.key_modal,
                                attrs: {
                                  small: "",
                                  dense: "",
                                  outlined: "",
                                  items: _vm.key_columns[_vm.item_modal.index],
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.item_modal.embedded_column,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.item_modal,
                                      "embedded_column",
                                      $$v
                                    )
                                  },
                                  expression: "item_modal.embedded_column",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VExpansionPanels,
                    [
                      _c(
                        VExpansionPanel,
                        [
                          _c(VExpansionPanelHeader, [
                            _vm._v("Configuración Avanzada"),
                          ]),
                          _c(
                            VExpansionPanelContent,
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-3" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [_vm._v("Chunk Size :")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-9" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          small: "",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          rules: _vm.rules.chunk,
                                        },
                                        model: {
                                          value: _vm.item_modal.chunk_size,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item_modal,
                                              "chunk_size",
                                              $$v
                                            )
                                          },
                                          expression: "item_modal.chunk_size",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-3" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [_vm._v("Chunk Overlap :")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-9" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          small: "",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          rules: _vm.rules.chunk,
                                        },
                                        model: {
                                          value: _vm.item_modal.chunk_overlap,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item_modal,
                                              "chunk_overlap",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item_modal.chunk_overlap",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "primary",
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addItem()
                    },
                  },
                },
                [_c(VIcon, [_vm._v("mdi-send")]), _vm._v("Aceptar ")],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: "dialog_edit_file",
          attrs: { title: "Editar archivo", width: 1500 },
          on: { onCloseClick: _vm.resetQuery },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(VTextField, {
                attrs: {
                  outlined: "",
                  label: "Buscar...",
                  dense: "",
                  clearable: "",
                  "append-icon": "mdi-magnify",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.get_file_rows($event)
                  },
                  "click:clear": _vm.get_file_rows,
                },
                model: {
                  value: _vm.rows_query_search,
                  callback: function ($$v) {
                    _vm.rows_query_search = $$v
                  },
                  expression: "rows_query_search",
                },
              }),
              _vm.rows.length
                ? _c(VDataTable, {
                    staticClass: "table-inca table-inca-detail",
                    attrs: {
                      headers: _vm.headers_rows,
                      items: _vm.rows,
                      dense: "",
                      "fixed-header": "",
                      height: "400px",
                      "per-page": _vm.pagination.limit,
                      "hide-default-footer": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "tr",
                                [
                                  _vm._l(
                                    Object.keys(item).filter(function (key) {
                                      return key !== "row_id"
                                    }),
                                    function (field, index) {
                                      return _c(
                                        "td",
                                        { key: index },
                                        [
                                          _c(
                                            VEditDialog,
                                            {
                                              attrs: {
                                                "return-value": item[field],
                                                large: "",
                                              },
                                              on: {
                                                "update:returnValue": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    item,
                                                    field,
                                                    $event
                                                  )
                                                },
                                                "update:return-value":
                                                  function ($event) {
                                                    return _vm.$set(
                                                      item,
                                                      field,
                                                      $event
                                                    )
                                                  },
                                                save: _vm.saveRow,
                                                cancel: _vm.cancelEdit,
                                                open: function ($event) {
                                                  return _vm.openEdit(
                                                    item,
                                                    field
                                                  )
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "input",
                                                    fn: function () {
                                                      return [
                                                        _c(VTextarea, {
                                                          attrs: { dense: "" },
                                                          model: {
                                                            value: item[field],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                field,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item[field]",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [_vm._v(_vm._s(item[field]))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveChanges(item)
                                            },
                                          },
                                        },
                                        [_vm._v("Guardar")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3321561525
                    ),
                  })
                : _vm._e(),
              _c("pagination-firestore", {
                key: _vm.key_pagination,
                attrs: { pagination: _vm.pagination },
                on: { changePagina: _vm.changePagina },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }